import { isNumber, isNumberWithinRange, isRequiredText, strMax } from './utils';
export const validateWhatRequest = [
    isRequiredText('依頼内容を入力してください'),
    strMax(2000, '依頼内容は2000文字以内で入力してください'),
];
export const validateConsiderations = [
    isRequiredText('検討内容を入力してください'),
    strMax(2000, '検討内容は2000文字以内で入力してください'),
];
export const validateTaskIssue = [
    isRequiredText('課題・お悩みを入力してください'),
    strMax(2000, '課題・お悩みは2000文字以内で入力してください'),
];
export const validateBudget = {
    budget: (value, record, props) => {
        if (record.budgetType !== '1') {
            return '';
        }
        let result = '';
        [
            isRequiredText('予算の確保状況を入力してください'),
            isNumber('正の整数を入力してください'),
            isNumberWithinRange(0, 99999, '予算の確保状況は99999万円以下で入力してください'),
        ].forEach((func) => {
            if (!result) {
                result = func(value, record, props);
            }
        });
        return result;
    },
};
export const validateContact = {
    aboutMeetingTool: [
        isRequiredText('ご希望のWeb面談ツールを入力してください'),
        strMax(2000, 'ご希望のWeb面談ツールは2000文字以内で入力してください'),
    ],
    contactableTime1: [
        isRequiredText('第一希望を入力してください'),
        strMax(255, '第一希望は255文字以内で入力してください'),
    ],
    contactableTime2: [strMax(255, '第二希望は255文字以内で入力してください')],
    contactableTime3: [strMax(255, '第三希望は255文字以内で入力してください')],
};
export const validateAdditionalInformation = [
    strMax(2000, '追加情報は2000文字以内で入力してください'),
];
